<app-header></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
<div class="phone1"><a href="tel:{{settings.phoneNo}}"><img src="/assets/telephone.png"></a></div>
<div class="what1"><a href="https://wa.me/{{settings.whatsapp}}"><img src="/assets/wp.png"></a></div>